import {Data} from '../../../types/tunings';
import {TrialStatus} from '../../../services/site-details.service';
import {SiteSearchEntryDto, SiteSearchResultDto} from '../../../../userway/sdk/UserWayApiClient';
import {createStore, withProps} from '@ngneat/elf';

export interface SitesState {
  activeSites: SiteSearchResultDto;
  activePdfSites: SiteSearchResultDto;
  deletedSites: SiteSearchResultDto;
  pendingSites: SiteSearchResultDto;
  currentSiteIsLoading: boolean;
  currentSite: SiteSearchEntryDto;
  sitesCount: number;
  siteTunings: Data;
  trial: TrialStatus;
  siteNotFound: boolean;
  isLoading: boolean;
}
export function createInitialSitesState(): SitesState {
  const initState: SiteSearchResultDto = {
    moreAvailable: false,
    pageIdx: 0,
    perPage: 0,
    sites: [],
    sitesAddonsTotal: null,
    sitesTotal: 0,
  };
  return {
    activeSites: initState,
    activePdfSites: initState,
    deletedSites: initState,
    pendingSites: initState,
    currentSiteIsLoading: false,
    currentSite: null,
    sitesCount: 0,
    siteTunings: {},
    trial: null,
    siteNotFound: false,
    isLoading: false,
  };
}

export const sitesStore = createStore({name: 'sites'}, withProps<SitesState>(createInitialSitesState()));
